import {B} from './pillars';

export const getRiskLevel=(score)=> {
  if (score < 2) return {label: "CRITICAL RISK",color: B.red};
  if (score < 3) return {label: "HIGH RISK",color: B.orange};
  if (score < 4) return {label: "MODERATE RISK",color: B.yellow};
  return {label: "LOW RISK",color: B.green};
};

export const getUrgency=(score)=> {
  if (score < 2) return {label: "ACT NOW",color: B.red,icon: "🚨",quarter: "Immediate"};
  if (score < 3) return {label: "ACT NOW",color: B.orange,icon: "⚠️",quarter: "This Quarter"};
  if (score < 3.5) return {label: "PLAN FOR Q2",color: B.yellow,icon: "📅",quarter: "Next Quarter"};
  return {label: "OPTIMIZE",color: B.green,icon: "✅",quarter: "6–12 Months"};
};

export const getBreachRiskIndex=(pillarScores)=> {
  const secScore=pillarScores.secure || 1;
  const opScore=pillarScores.operate || 1;
  const weighted=(secScore * 0.55) + (opScore * 0.30) + (secScore * 0.15);
  const index=Math.round(Math.max(1,Math.min(10,((5 - weighted) / 4) * 9 + 1)));
  const label=index >=8 ? "CRITICAL" : index >=6 ? "HIGH" : index >=4 ? "ELEVATED" : "MANAGED";
  const color=index >=8 ? B.red : index >=6 ? B.orange : index >=4 ? B.yellow : B.green;
  const description=
    index >=8 ? "Security posture is severely underdeveloped. Likelihood of a breach event within 12 months is significant without immediate remediation." :
    index >=6 ? "Multiple high-priority security gaps create meaningful exposure. Prioritize identity,endpoint,and backup hardening." :
    index >=4 ? "Core controls are partially in place but gaps remain. A structured remediation plan will meaningfully reduce exposure." :
    "Security posture is solid. Focus on continuous improvement and compliance alignment.";
  return {index,label,color,description};
};

export const getRecs=(scores,vertical)=> {
  const all=[
    {
      pillar: "secure",
      threshold: 3,
      title: "Endpoint & Perimeter Vulnerabilities",
      risk: "Devices may be compromised by malware or ransomware without detection. A single unprotected endpoint can cascade into a full network breach.",
      action: "Standardize next-generation MDR on all devices and audit edge firewall configurations. MDR adds human analyst oversight to automated detection — ensuring threats are investigated and contained, not just alerted.",
      solution: "VEIT Sentinel MDR: 24/7 Managed Detection & Response with human SOC analyst escalation and active threat hunting.",
      compliance: vertical==="Healthcare" ? "Required for HIPAA Security Rule §164.312(a)(1)" : vertical==="Financial Services" ? "Aligns to PCI-DSS Req. 5 & SOX IT controls" : null,
    },
    {
      pillar: "operate",
      threshold: 3,
      title: "No Proactive IT Monitoring",
      risk: "Issues go undetected until they cause downtime,increasing mean time to recovery and eroding employee productivity.",
      action: "Deploy 24/7 RMM monitoring with NOC oversight. Move from break-fix to managed services.",
      solution: "VEIT Managed Operations: 24/7 RMM with NOC-led patch management and US-based help desk.",
    },
    {
      pillar: "secure",
      threshold: 3,
      title: "Identity & Access Exposure",
      risk: "Without MFA and conditional access,credential theft is the #1 attack vector for SMBs. 81% of breaches involve stolen passwords.",
      action: "Implement MFA across all applications using Microsoft Entra ID with conditional access policies.",
      solution: "VEIT Identity Shield: Entra ID + MFA deployment with SSO integration.",
    },
    {
      pillar: "operate",
      threshold: 3,
      title: "Backup & Disaster Recovery Gaps",
      risk: "Without tested,offsite backup,a ransomware attack or hardware failure could result in permanent data loss and weeks of recovery time.",
      action: "Deploy cloud-based immutable backup with documented RTO/RPO targets and quarterly DR tests.",
      solution: "VEIT DataGuard: Immutable cloud backup with automated recovery testing and BCP documentation.",
    },
    {
      pillar: "modernize",
      threshold: 3,
      title: "Cloud & M365 Modernization Lag",
      risk: "Legacy infrastructure limits collaboration,increases maintenance costs,and creates security debt.",
      action: "Migrate to M365 Business Premium or E3/E5. Develop a phased cloud migration roadmap.",
      solution: "VEIT Cloud Forward: M365 deployment,SharePoint migration,and Copilot readiness assessment.",
    },
    {
      pillar: "ai",
      threshold: 3,
      title: "AI Readiness & Process Automation Gap",
      risk: "Organizations not piloting AI tools today will face a 2–3 year competitive gap.",
      action: "Conduct an AI readiness assessment,deploy M365 Copilot for target users,and automate 3–5 high-volume workflows.",
      solution: "VEIT AI Launchpad: Copilot deployment,Power Automate workflow builds,and AI governance policy.",
    },
    {
      pillar: "print",
      threshold: 3,
      title: "Unmanaged Print Fleet & Document Risk",
      risk: "Unmanaged print environments carry hidden costs and create document security gaps.",
      action: "Conduct a fleet assessment,implement Managed Print Services,and enable secure badge-release printing.",
      solution: "VEIT MPS360: Zero-touch supply fulfillment,secure print release,fleet analytics,and DMS integration.",
    },
    {
      pillar: "ai",
      threshold: 4,
      title: "Data Governance & AI Security Posture",
      risk: "Without sensitivity labels and DLP policies,AI tools may expose confidential data.",
      action: "Implement Microsoft Purview for data classification,DLP,and sensitivity labeling.",
      solution: "VEIT Data Shield: Purview deployment,sensitivity label taxonomy,and AI data governance policy.",
    },
  ];
  return all.filter(r=> (scores[r.pillar] || 5) < r.threshold).slice(0,6);
};